import { useQuery } from "@tanstack/react-query";
import analyticsService from "../../services/analytics/analytics.service";

// 0024: agent analytics, scoped SERVER-SIDE to the caller's assigned customers (M4).
// Keyed on the token so each agent gets their own cached numbers and a re-login refetches.
const useAgentAnalyticsQuery = ({ enabled = true } = {}) => {
  const token = localStorage.getItem("jwtToken");
  return useQuery({
    queryKey: ["analytics", "agent", token],
    queryFn: () => analyticsService.getAgentSummary().then((r) => r.data.payload),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export default useAgentAnalyticsQuery;
